module.exports = __webpack_public_path__ + "img/4.be2455b7.jpg";